export default __webpack_public_path__ + "static/media/watchDetails.303b3e7e.svg";